module.exports = {
  hk: {
    std: {
      name: "Standard - 5-7 Business Days",
      default: true
    }
  },
  tw: {
    std: {
      name: "Standard - 5-7 Business Days",
      default: true
    }
  },
  au: {
    std: {
      name: "Standard - 7-14 Business Days",
      default: true
    }
  },
  be: {
    std: {
      name: "Standard - 7-14 Business Days",
      default: true
    }
  },
  br: {
    std: {
      name: "Standard - 7-14 Business Days",
      default: true
    }
  },
  kh: {
    std: {
      name: "Standard - 7-14 Business Days",
      default: true
    }
  },
  ca: {
    std: {
      name: "Standard - 7-14 Business Days",
      default: true
    }
  },
  dk: {
    std: {
      name: "Standard - 7-14 Business Days",
      default: true
    }
  },
  fi: {
    std: {
      name: "Standard - 7-14 Business Days",
      default: true
    }
  },
  fr: {
    std: {
      name: "Standard - 7-14 Business Days",
      default: true
    }
  },
  de: {
    std: {
      name: "Standard - 7-14 Business Days",
      default: true
    }
  },
  id: {
    std: {
      name: "Standard - 7-14 Business Days",
      default: true
    }
  },
  ie: {
    std: {
      name: "Standard - 7-14 Business Days",
      default: true
    }
  },
  il: {
    std: {
      name: "Standard - 14-16 Business Days",
      default: true
    }
  },
  jp: {
    std: {
      name: "Standard - 7-14 Business Days",
      default: true
    }
  },
  mo: {
    std: {
      name: "Standard - 7-14 Business Days",
      default: true
    }
  },
  cn: {
    std: {
      name: "Standard - 5-7 Business Days",
      default: true
    }
  },
  my: {
    std: {
      name: "Standard - 7-14 Business Days",
      default: true
    }
  },
  nl: {
    std: {
      name: "Standard - 7-14 Business Days",
      default: true
    }
  },
  nz: {
    std: {
      name: "Standard - 7-14 Business Days",
      default: true
    }
  },
  no: {
    std: {
      name: "Standard - 11-19 Business Days",
      default: true
    }
  },
  ph: {
    std: {
      name: "Standard - 7-14 Business Days",
      default: true
    }
  },
  pl: {
    std: {
      name: "Standard - 7-14 Business Days",
      default: true
    }
  },
  pt: {
    std: {
      name: "Standard - 7-14 Business Days",
      default: true
    }
  },
  ru: {
    std: {
      name: "Standard - 7-14 Business Days",
      default: true
    }
  },
  sg: {
    std: {
      name: "Standard - 7-14 Business Days",
      default: true
    }
  },
  kr: {
    std: {
      name: "Standard - 4-7 Business Days",
      default: true
    }
  },
  es: {
    std: {
      name: "Standard - 7-14 Business Days",
      default: true
    }
  },
  se: {
    std: {
      name: "Standard - 7-14 Business Days",
      default: true
    }
  },
  ch: {
    std: {
      name: "Standard - 10-14 Business Days",
      default: true
    }
  },
  th: {
    std: {
      name: "Standard - 7-14 Business Days",
      default: true
    }
  },
  tr: {
    std: {
      name: "Standard - 11-18 Business Days",
      default: true
    }
  },
  gb: {
    std: {
      name: "Standard - 4-7 Business Days",
      default: true
    }
  },
  us: {
    std: {
      name: "Standard - 7-14 Business Days",
      default: true
    }
  },
  vn: {
    std: {
      name: "Standard - 7-14 Business Days",
      default: true
    }
  },
  default: {
    std: {
      name: "Standard - 7-14 Business Days",
      default: true
    }
  }
};



// WEBPACK FOOTER //
// ./src/data/shipping.js